import React, { type ReactNode } from "react";
interface EmptyStateProps {
  illustration: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  className?: string;
}
export default function EmptyState({
  illustration,
  children,
  actions,
  className = "flex flex-col justify-center items-center w-full",
}: EmptyStateProps): React.ReactElement {
  return (
    <div className={className}>
      {illustration}
      {children}
      {actions}
    </div>
  );
}
